module.exports = __webpack_public_path__ + "static/2-f224cca7860c5fd49bd548ebe6a2680f.jpg";